var QuadRowPackageData = require('./quadRowPackageData.js');
var lib_core = require("lib-core");
var ComponentAttribute = require('./componentAttribute.js');

var QfnData = function(position, angle, init) {
    QuadRowPackageData.apply(this, arguments);

    if(init) this.padShape(ComponentAttribute.padShapes["Oblong"]);
};

lib_core.inherit(QfnData, QuadRowPackageData);
lib_core.JsonParser.registerClass(QfnData, "QfnData");

module.exports = QfnData;

